import { useReviews } from 'hooks/review/useReviews';

import { Title } from '../Title/Title';
import { Review } from './Review';

import s from './Reviews.module.css';
import s1 from 'themes/playful/components/PlayfulLayout.module.css';

export const PlayfulReviewList = () => {
  const { visibleReviews, hasMoreReviews, showMoreReviews } = useReviews();

  return (
    <section className={s.reviews} id="reviews">
      <div className={s1.content}>
        <div className={s.wrapper}>
          <Title className={s.title}>Reviews</Title>
          <div className={s.content}>
            {visibleReviews.map((review) => (
              <Review key={review.id} review={review} />
            ))}
          </div>
        </div>
        {hasMoreReviews && (
          <div className={s.moreReviewsWrapper}>
            <button className={s.moreButton} onClick={showMoreReviews}>
              Show more reviews
            </button>
          </div>
        )}
      </div>
    </section>
  );
};
